import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const verifyUser = async ({
  user_id,
  is_verified,
}: {
  user_id: string;
  is_verified: boolean;
}): Promise<ApiResponse<unknown>> => {
  return await apiClient.patch(`user/${user_id}/verify`, { is_verified });
};

export function verifyUserMutationOptions() {
  return mutationOptions<
    ApiResponse<unknown>,
    AxiosError,
    { user_id: string; is_verified: boolean }
  >({
    mutationFn: verifyUser,
  });
}
